import { render, staticRenderFns } from "./PreferencesTab.vue?vue&type=template&id=6b4290f5&scoped=true"
import script from "./PreferencesTab.vue?vue&type=script&lang=js"
export * from "./PreferencesTab.vue?vue&type=script&lang=js"
import style0 from "./PreferencesTab.vue?vue&type=style&index=0&id=6b4290f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4290f5",
  null
  
)

export default component.exports